module.exports = __webpack_public_path__ + "static/media/015_iOS - 17 - COST & COVERAGE loading.27b23180.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/015_iOS - 17 - COST & COVERAGE loading.png
// module id = 512
// module chunks = 0